import { IconButton } from "@fluentui/react";
import * as React from "react";
import { FunctionComponent } from "react";

interface Props {
  title: string;
  onBackClick?: () => void;
}

const BackHeader: FunctionComponent<Props> = (props: Props) => {
  const { title, onBackClick } = props;

  return (
    <div style={{ display: "flex", padding: 10 }}>
      <div style={{ flex: 1 }}>
        <IconButton
          iconProps={{ iconName: "Back", style: { fontSize: 20, color: "#AEAEAE" } }}
          title="Back"
          ariaLabel="Back"
          onClick={onBackClick}
        />
      </div>
      <div style={{ flex: 9, fontWeight: "bold", fontSize: 18, textAlign: "center", paddingRight: 20 }}>{title}</div>
    </div>
  );
};

export default BackHeader;
